<template>
  <div class="container pt-5">
    <!--      <div class="text-center vh-100 d-flex align-items-center justify-content-center">-->
    <!--        <h1 class="h1">Please buy my software</h1>-->
    <!--      </div>-->
    <!--      <TestTabapay/>-->
    <!--      <div>yandex: {{ yandex }}ms</div>-->
    <!--      <div>hetzner: {{ hetzner }}ms</div>-->
    <!--      <button @click="refresh">Refresh</button>-->
    <!--      <CryptoProSignWidget v-if="cryptoLib"-->
    <!--                           data-to-sign="cda"-->
    <!--                           @signed="signed"/>-->
    <!--      <CryptoProBrowserSignWidget v-else-->
    <!--                                  data-to-sign="cda"-->
    <!--                                  @signed="signed"/>-->
    <!--      <div class="pt-5 text-wrap">{{ signature }}</div>-->
    <!--      <a @click="kkmTest">Test me, baby, one more time!</a>-->
    <!--      <a @click="awaitTest">await test</a>-->
    <!--      <TestNCLayer/>-->
    <!--      <b-modal id="fff"-->
    <!--               size="lg"-->
    <!--               :title="$t('calendar_settings')"-->
    <!--               @hide="modalResolve('error')"-->
    <!--               centered>-->
    <!--        <a @click="modalResolve('success')">resolve success</a>-->
    <!--        <a @click="modalResolve('error')">resolve error</a>-->
    <!--        <a @click="modalReject">resolve error</a>-->
<!--    <a @click="imitateLogin">il</a>-->
    <!--      </b-modal>-->
    <!--      <div>-->
    <!--        <code>{{ result }}</code>-->
    <!--      </div>-->
  </div>
</template>

<script setup>
// import { TestService } from "@/services/api/test.api.service"
// import KKMService from "@/services/kkm.service"
// import {ref} from "vue"
// import {TestService} from "@/services/api/test.api.service"
// import JwtService from "@/services/jwt.service"
// import {useRoute } from "vue-router"
// import {saveBranch} from "@/services/branch.helper"
// import TestNCLayer from "@/components/pages/settings/TestNCLayer.vue"
// import TestTabapay from "@/components/pages/settings/TestTabapay.vue"
// import CryptoProSignWidget from "@/components/parts/egisz/CryptoProSignWidget.vue"
// import CryptoProBrowserSignWidget from "@/components/parts/egisz/CryptoProBrowserSignWidget.vue"
// const route = useRoute()

// const signature = ref(null)

// const signed = (val) => {
//   console.log(val)
//   signature.value = val
// }
//
// const kkmTest = async () => {
//   this.result = await KKMService.printXReport()
// }
//
// const awaitTest = async () => {
//   const res = await modalTest()
//   console.log(res)
//   console.log('asdadf')
// }
//
// const modalTest = async () => {
//   return new Promise((resolve, reject) => {
//     this.$bvModal.show('fff')
//     this.modalReject = reject
//     this.modalResolve = resolve
//   })
// }

// refresh() {
//   this.hetzner = null
//   this.yandex = null
//   TestService.hetznerTest().then(res => {
//     this.hetzner = res.data
//   }).catch(() => {})
//   TestService.yandexTest().then(res => {
//     this.yandex = res.data
//   }).catch(() => {})
// },

// const imitateLogin = async () => {
//   const uid = route.query.uid
//   const res = await TestService.loginTest(uid)
//   if(res.data.token) {
//     JwtService.destroyToken()
//     JwtService.saveToken(res.data.token, false)
//     if(res.data.branchId) {
//       saveBranch(res.data.branchId)
//     }
//     setTimeout(() => {
//       window.location.href = window.location.origin
//     }, 1000) // to allow databases to sync
//   }
// }
</script>
